<template>
  <div class="door-title">
    <img src="./img/DIYtitleFont.png" />
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "doorTitle",
};
</script>
<style lang="scss" scoped>
.door-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  height: 20px;
  font-size: 20px;
  font-weight: 500;
  color: #e2effd;
  line-height: 20px;

  img {
    margin-right: 10px;
    width: 2px;
    height: 20px;
  }
}
</style>